/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AfricaTalkingOptOutNotif } from '../model/africaTalkingOptOutNotif';
import { AfricaTalkingSubscriptionNotif } from '../model/africaTalkingSubscriptionNotif';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AfricaTalkingService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param date 
     * @param from 
     * @param id 
     * @param linkId 
     * @param text 
     * @param to 
     * @param networkCode 
     * @param requestSource 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public africaTalkingIncomingNotificationEncoded(date?: string, from?: string, id?: string, linkId?: string, text?: string, to?: string, networkCode?: string, requestSource?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public africaTalkingIncomingNotificationEncoded(date?: string, from?: string, id?: string, linkId?: string, text?: string, to?: string, networkCode?: string, requestSource?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public africaTalkingIncomingNotificationEncoded(date?: string, from?: string, id?: string, linkId?: string, text?: string, to?: string, networkCode?: string, requestSource?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public africaTalkingIncomingNotificationEncoded(date?: string, from?: string, id?: string, linkId?: string, text?: string, to?: string, networkCode?: string, requestSource?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (date !== undefined) {
            formParams = formParams.append('Date', <any>date) || formParams;
        }
        if (from !== undefined) {
            formParams = formParams.append('From', <any>from) || formParams;
        }
        if (id !== undefined) {
            formParams = formParams.append('Id', <any>id) || formParams;
        }
        if (linkId !== undefined) {
            formParams = formParams.append('LinkId', <any>linkId) || formParams;
        }
        if (text !== undefined) {
            formParams = formParams.append('Text', <any>text) || formParams;
        }
        if (to !== undefined) {
            formParams = formParams.append('To', <any>to) || formParams;
        }
        if (networkCode !== undefined) {
            formParams = formParams.append('NetworkCode', <any>networkCode) || formParams;
        }
        if (requestSource !== undefined) {
            formParams = formParams.append('RequestSource', <any>requestSource) || formParams;
        }

        return this.httpClient.post(`${this.basePath}/api/AfricaTalking/IncomingNotificationEncoded`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public africaTalkingOptout(model: AfricaTalkingOptOutNotif, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public africaTalkingOptout(model: AfricaTalkingOptOutNotif, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public africaTalkingOptout(model: AfricaTalkingOptOutNotif, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public africaTalkingOptout(model: AfricaTalkingOptOutNotif, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling africaTalkingOptout.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/AfricaTalking/optout`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public africaTalkingSubscriptionNotification(model: AfricaTalkingSubscriptionNotif, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public africaTalkingSubscriptionNotification(model: AfricaTalkingSubscriptionNotif, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public africaTalkingSubscriptionNotification(model: AfricaTalkingSubscriptionNotif, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public africaTalkingSubscriptionNotification(model: AfricaTalkingSubscriptionNotif, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling africaTalkingSubscriptionNotification.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/AfricaTalking/subcriptionnotif`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param phoneNumber 
     * @param shortCode 
     * @param keyword 
     * @param updateType 
     * @param requestSource 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public africaTalkingSubscriptionNotificationEncoded(phoneNumber?: string, shortCode?: string, keyword?: string, updateType?: string, requestSource?: string, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public africaTalkingSubscriptionNotificationEncoded(phoneNumber?: string, shortCode?: string, keyword?: string, updateType?: string, requestSource?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public africaTalkingSubscriptionNotificationEncoded(phoneNumber?: string, shortCode?: string, keyword?: string, updateType?: string, requestSource?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public africaTalkingSubscriptionNotificationEncoded(phoneNumber?: string, shortCode?: string, keyword?: string, updateType?: string, requestSource?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {






        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (phoneNumber !== undefined) {
            formParams = formParams.append('PhoneNumber', <any>phoneNumber) || formParams;
        }
        if (shortCode !== undefined) {
            formParams = formParams.append('ShortCode', <any>shortCode) || formParams;
        }
        if (keyword !== undefined) {
            formParams = formParams.append('Keyword', <any>keyword) || formParams;
        }
        if (updateType !== undefined) {
            formParams = formParams.append('UpdateType', <any>updateType) || formParams;
        }
        if (requestSource !== undefined) {
            formParams = formParams.append('RequestSource', <any>requestSource) || formParams;
        }

        return this.httpClient.post<number>(`${this.basePath}/api/AfricaTalking/subcriptionnotifencoded`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
